// extracted by mini-css-extract-plugin
module.exports = {"accordion":"accordion_accordion__zSaTt","header":"accordion_header__MH9Qm","title":"accordion_title__GJYU8","icon":"accordion_icon__QYHCE","content":"accordion_content__PQVMT"};